import { useEffect, useMemo, useState } from "react";

import './../Clients.css';

import Axios from 'axios';

import Comp_PageName from "../../../components/PageName";
import { Btn, Input_Password, Input_Text, File } from "../../../components/Input";

import Env from "../../../services/Env";
import { OpenPage } from "../../../services/OpenPage";
import { CallbackError, CallbackSuccess, CheckPassword } from "../../../services/Function";

import { GetDataPage, RegisterDataPage, SetListDataSingleItem, UnRegisterDataPage } from "../../../interface/Data";
import { SetStatusGlobal } from "../../../interface/Global";
import { SetModalData, SetModalState } from "../../../interface/PopUp";
import { OnlyLetters } from "../../../fixedData";
import { stat } from "fs";

interface ResponseData {
    id             : number;
    version        : string;
    status         : number;
    file           : string;
    favicon        : string;
    comporate_name : string;
    title          : string;
    description    : string;
    name_link      : string;
    qtd_projects   : string;
    login_name     : string;
    login_email    : string;
    login_password : string;
    bd_name        : string;
    subdominio     : string;
    date_to_delete : string | null;
    register_id    : string;
    register_date  : string;
    removed_id     : string;
    removed_date   : string | null;
    status_data    : boolean;
}

// Tempo que a tela continua travada DEPOIS que o cadastro responde. A api
// devolve assim que grava o cliente, mas subdominio, AutoSSL, banco e copia do
// site continuam rodando em seguida - mexer na tela nesse meio tempo deixa o
// cliente pela metade.
const RELEASE_DELAY = 50000;

export default function Page_Clients_Details() {

    const [ listData, setListData ] = useState<{ [key: string]: ResponseData }>(GetDataPage("clients") || {});
    
    const [ pageId, setPageId ] = useState<number>(localStorage.getItem('page_id') ? parseInt(localStorage.getItem('page_id') as string) : 0);
    const [ closing, setClosing ] = useState<boolean>(false);
    
    const [ status, setStatus ] = useState<number>(0);
    const [ file, setFile ] = useState<File | string | null>(null);
    const [ favicon, setFavicon ] = useState<File | string | null>(null);
    const [ comporateName, setComporateName ] = useState<string>('');
    const [ pageTitle, setPageTitle ] = useState<string>('');
    const [ description, setDescription ] = useState<string>('');
    const [ nameLink, setNameLink ] = useState<string>('');
    const [ qtdProjects, setQtdProjects ] = useState<string>('');
    const [ loginName, setLoginName ] = useState<string>('');
    const [ loginEmail, setLoginEmail ] = useState<string>('');
    const [ password, setPassword ] = useState<string>('');
    const [ password2, setPassword2 ] = useState<string>('');

    const passwordCheck = useMemo(() => CheckPassword(password, password2), [password, password2]);

    // Chamado quando o contador chega a zero, nunca antes: enquanto ele corre o
    // provisionamento (subdominio, AutoSSL, banco e copia) ainda esta rodando.
    function ReturnClientFinish(){
        CallbackSuccess("Saved information", "The client details have been successfully saved.");
    }

    // Clicar no fundo escurecido (fora do painel) fecha igual ao botao Cancel.
    function handleBackdrop(event: React.MouseEvent<HTMLFormElement>){
        if(event.target === event.currentTarget){
            handleClose();
        }
    }

    function handleClose() {        
        localStorage.removeItem('page_id');
        setClosing(true);
        setTimeout(() => {
            OpenPage('clients');
        }, 300);
    }

    async function SaveData(event: React.FormEvent<HTMLFormElement>) {
        event.preventDefault();
        const passwordFilled = password !== '' || password2 !== '';
        const shouldValidatePassword = pageId === 0 || passwordFilled;

        if (shouldValidatePassword && !Object.values(passwordCheck).every(Boolean)){
                CallbackError("Password Error", "Please ensure the password meets all the requirements and both fields match.");
            return;
        }else {
            // pageId vira o insert_id no meio do try, entao o valor de agora e o
            // unico que ainda diz se isto e cadastro novo ou edicao.
            const newRegister = pageId === 0;

            // O contador so faz sentido se o cliente foi realmente gravado.
            let saved = false;

            // Trava a tela antes da requisicao sair. O overlay do App e fixed em
            // tela cheia com z-index 9999, entao ligar o loading ja basta para
            // impedir qualquer clique.
            SetStatusGlobal('loading', true);

            try {                
                const formData = new FormData();
                formData.append('type_page', 'clients');
                formData.append('type_data', 'edit_or_register');
                formData.append('id', String(pageId));
                
                formData.append('file', file !== null ? file : '');
                formData.append('favicon', favicon !== null ? favicon : '');
                formData.append('status', String(status));
                formData.append('comporateName', comporateName);
                formData.append('title', pageTitle);
                formData.append('description', description);
                formData.append('nameLink', nameLink);
                formData.append('qtdProjects', qtdProjects);
                formData.append('loginName', loginName);
                formData.append('loginEmail', loginEmail);
                formData.append('password', password);
                formData.append('token', localStorage.getItem('token') || '');

                const response = await Axios.post<ResponseData>(Env.apiUrl, formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                });
                
                if(response.data.status_data){   
                    const newId = response.data.id;

                    setPageId(newId);
                    setFile(response.data.file);
                    setFavicon(response.data.favicon);
                    setComporateName(response.data.comporate_name);
                    setPageTitle(response.data.title);
                    setDescription(response.data.description);
                    setNameLink(response.data.name_link);
                    setQtdProjects(response.data.qtd_projects);
                    setLoginName(response.data.login_name);
                    setLoginEmail(response.data.login_email);

                    localStorage.setItem('page_id', newId.toString());
                    SetListDataSingleItem('clients', newId, response.data);
                    
                    saved = true;

                    // No cadastro novo a confirmacao vem depois do contador: os dois sao
                    // PopUp em tela cheia e ficariam empilhados.
                    if(!newRegister){
                        CallbackSuccess("Saved information", "The client details have been successfully saved.");
                    }

                }else {
                    CallbackError("Error saving information", "There was an issue saving the client details. Please try again.");
                }
                
            }catch (error){
                CallbackError("Error saving information", "There was an issue saving the client details. Please try again.");

            }finally {
                // O timer so comeca aqui, depois que a requisicao respondeu -
                // nunca em paralelo com ela. Na edicao nao ha provisionamento
                // rodando por tras, entao a tela e liberada na hora.
                SetStatusGlobal('loading', false);

                if(newRegister && saved){
                    // O contador troca o loading mudo, mas continua travando a tela: o
                    // PopUp tambem e fixed em tela cheia com z-index 9999. A diferenca
                    // e que agora da para ver quanto falta.
                    SetModalData('CreationTime', {
                        "ReturnProjectFinish" : ReturnClientFinish,
                        "onlyClose"           : false,
                        "counterCreation"     : RELEASE_DELAY / 1000,
                        "message"             : "The client creation will be finalized in"
                    });
                    SetModalState('CreationTime', true);
                }

                // Gravou: o painel fecha e volta para a listagem. O PopUp (sucesso na
                // edicao, contador no cadastro novo) e global, entao segue na tela
                // mesmo depois do Details sair.
                if(saved){
                    handleClose();
                }
            }
        }
    }

    useEffect(() => {
        function handleData(data: any) {
            setListData(data || {});
        }
        RegisterDataPage('clients', handleData);
        return () => UnRegisterDataPage('clients', handleData);
    }, []);

    useEffect(() => {
        if (pageId !== 0 && Object.keys(listData).length > 0) {
            const showInf = listData[pageId];
            if (showInf) {
                setStatus(showInf.status || 1);
                setFile(showInf.file || '');
                setFavicon(showInf.favicon || '');
                setComporateName(showInf.comporate_name || '');
                setPageTitle(showInf.title || '');
                setDescription(showInf.description || '');
                setNameLink(showInf.name_link || '');
                setQtdProjects(showInf.qtd_projects || '');
                setLoginName(showInf.login_name || '');
                setLoginEmail(showInf.login_email || '');
            }
        }
    }, [listData, pageId]);

    useEffect(()=>{
        setPageId(localStorage.getItem('page_id') ? parseInt(localStorage.getItem('page_id') as string) : 0);
    }, [localStorage.getItem('page_id')]);

    return(
        <form className="page_details Page_Clients_Details" onSubmit={ SaveData } onClick={ handleBackdrop }>
            <div className={ `content_details ${ closing ? 'content_details_close' : '' }` }>
                
                <Comp_PageName 
                    title={ pageId === 0 ? "Add Client" : "Edit Client" }
                    subtitle={ pageId === 0 ? "Fill in the details to add a new client" : "Update the details of the client" }
                />

                <div className="div_btn div_row">
                    <File title="Upload your logo" subtitle="If you do not upload your logo, your avatar will be the initials of your company name." file={ typeof file === 'string' ? file : undefined } setValue={ setFile } />

                    <File title="Upload your favicon" subtitle="Icon shown on the browser tab. If you do not upload one, the logo will be used." file={ typeof favicon === 'string' ? favicon : undefined } setValue={ setFavicon } />
                </div>

                <div className="div_btn div_row">
                    <div className="input">
                        <Input_Text title="Comporate Name" type="text" value={ comporateName } setValue={ setComporateName } placeholder="Enter your company name" required={ true } />
                    </div>
                    
                    <div className="input">
                        <Input_Text title="Name link" type="text" value={ nameLink } setValue={ setNameLink } placeholder="Enter your name link" required={ true } readOnly={ pageId !== 0 } />
                    </div>

                    <div className="input div_qtd">
                        <Input_Text title="Qtd Projects" type="text" value={ qtdProjects } setValue={ setQtdProjects } placeholder="" required={ true } />
                    </div>
                </div>

                <div className="div_btn">
                    <div className="input">
                        <Input_Text title="Page title" type="text" value={ pageTitle } setValue={ (value: string) => setPageTitle(OnlyLetters(value)) } placeholder="Enter the page title" maxLength={ 50 } />
                    </div>
                </div>

                <div className="div_btn">
                    <div className="input">
                        <Input_Text title="Description" type="text" value={ description } setValue={ setDescription } placeholder="Enter the page description" maxLength={ 255 } />
                    </div>
                </div>

                <div className="div_btn div_row">
                    <div className="input">
                        <Input_Text title="Name login" type="text" value={ loginName } setValue={ setLoginName } placeholder="Enter your name login" required={ true } />
                    </div>
                    
                    <div className="input">
                        <Input_Text title="Email login" type="email" value={ loginEmail } setValue={ setLoginEmail } placeholder="Enter your email login" required={ true } />
                    </div>
                </div>

                <div className="div_btn div_row">
                    <div className="input">
                        <Input_Password title="Password" value={ password } setValue={ setPassword } placeholder="Enter your new password" required={ pageId === 0 } />
                    </div>

                    <div className="input">
                        <Input_Password title="Confirm Password" value={ password2 } setValue={ setPassword2 } placeholder="Confirm your new password" required={ pageId === 0 } />
                    </div>
                </div>

                <div className="type_password">
                    <div className={ passwordCheck.minLength ? "yes_save" : "not_save" }>The password must be at least 6 characters long.</div>
                    <div className={ passwordCheck.special   ? "yes_save" : "not_save" }>The password must contain special characters.</div>
                    <div className={ passwordCheck.hasNumber ? "yes_save" : "not_save" }>The password must contain at least 1 number.</div>
                    <div className={ passwordCheck.hasUpper  ? "yes_save" : "not_save" }>The password must contain at least 1 uppercase letter.</div>
                    <div className={ passwordCheck.match     ? "yes_save" : "not_save" }>The passwords must match.</div>
                </div>

                <div className="div_btn div_row">
                    <Btn title="Cancel" type="btn_cancel" OpenFuncition={ handleClose } />
                    <Btn title="Save" />
                </div>
            </div>
        </form>
    )
}